import { type EntityFormState } from "@/app/EntityDrawer";
import type { Channel, ChannelGroup } from "@/app/master";
import { Combobox, Field, Grid, Input } from "@/ui";
import { ItemConditions } from "./RoutingConditionFields";
import { type RoutingRuleDraft } from "./routingRuleDraft";
import { targetOptions } from "./targetDraft";

/** 独立规则编辑字段：通道或通道组合目标与 MCC/MNC/Sender 条件，优先级留给绑定（D131、D132）。 */
export function RoutingRuleForm({ draft, errors, set, groups, channels, disabled }: EntityFormState<RoutingRuleDraft> & {
  groups: ChannelGroup[]; channels: Channel[]; disabled: boolean;
}) {
  return <Grid>
    <Field label="规则名称" htmlFor="rule-name" error={errors.name}><Input id="rule-name" value={draft.name} onChange={e => set("name", e.target.value)} /></Field>
    <Field label="匹配条件" error={errors.item} hint="只按 MCC、MNC 与 Sender 匹配；MNC 按字符串匹配，空值表示不限，保留前导零。">
      <ItemConditions item={draft.item} n={1} onChange={patch => set("item", { ...draft.item, ...patch })} />
    </Field>
    <Field label="发送目标" hint="规则只指向通道或通道组合；路由模板由账号绑定直接选择。命中后目标不可用时返回无路由，不继续匹配后续账号绑定。">
      <Combobox searchable block disabled={disabled} ariaLabel="规则发送目标" value={draft.item.target || null} onChange={target => set("item", { ...draft.item, target })}
        options={targetOptions(groups, channels)} />
    </Field>
  </Grid>;
}
